<template>
  <div
    class="border-top border-dark"
    style="display:flex; background-color:rgb(204,255,179)"
  >
    <div
      class="p-1 column50 text-center text-bold border-left border-right border-dark "
    >
      TOTAL
    </div>
    <div
      class="p-1 text-center text-bold border-right border-dark"
      style="width:7%"
    >
      100%
    </div>
    <div
      class="p-1 text-center text-bold border-right border-dark"
      style="width:8%;height: auto"
    ></div>
    <div class="p-1 column15 text-center text-bold border-right border-dark">
      {{ total }}
    </div>
    <div
      class="p-1 border-right border-dark"
      style="height: auto;width:20%"
    ></div>
  </div>
</template>
<script>
export default {
  props: ['total'],
}
</script>
